import DialogDetails from './DialogDetails';
export default DialogDetails;
export { default as DialogDetails } from './DialogDetails';